import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../components/Table";
import PackageItem from "./PackageItem";
import PackageTrackableItem from "./PackageTrackableItem";
import ShippingLabelStorage from "../../lib/ShippingLabelStorage";
import {showContextualMenu} from "../../actions/ViewActions";
import {hasIndividualPackageHandlingCapability} from "../../lib/Couriers";
import {
  requestRemovePackageFromShippingOrder, 
  requestChangePackageDeliveryStatusDelivered, 
  requestChangePackageDeliveryStatusPickedUp
} from "../../actions/ShippingApiActions";
import {List} from "immutable";

class PackagesList extends Component {

  render() {
    let fulfillmentStatus = this.props.fulfillmentStatus;
    let tableHeader = List([
      "Dimensions",
      "Inventory",
      ""
    ])
    let renderer = PackageItem;

    if (fulfillmentStatus !== "preparation" && fulfillmentStatus !== "cancelled") {
      tableHeader = List([
        "Pkg. Id",
        "Tracking Nr.",
        "Dimensions",
        "Inventory",
        "Label",
        ""
      ])
      renderer = PackageTrackableItem;
    }

    return (
      <Table 
        data={this.props.packages} 
        renderer={renderer} 
        rendererParams={{courierId: this.props.courierId}}
        onItemClick={this.handleItemClick.bind(this)}
        tableHeader={tableHeader}
        extraClassName="PackagesList"
        itemKey="packageId"
        mode="table"
        selected={this.props.selectedId}
        onContextMenuClick={this.handleContextMenuClick.bind(this)}
        />
    )
  }

  handleItemClick(itemData, e, field = "") {
    let id = itemData.get("packageId");
    if (field === "label") {
      e.stopPropagation();
      let downloadUrl = ShippingLabelStorage.getUrl(this.props.orderId, itemData.get("trackingNr"));
      ShippingLabelStorage.download(downloadUrl);
      return;
    }
    this.props.onSelectionChange(id);
  }  

  handleContextMenuClick(itemData, x, y) {
    let items = [
      {label: "Remove", cmd: requestRemovePackageFromShippingOrder(this.props.orderId, itemData.get("packageId"))}
    ];
    if (hasIndividualPackageHandlingCapability(this.props.courierId)) {
      items.push({label: "Mark as Picked Up", cmd: requestChangePackageDeliveryStatusPickedUp(this.props.orderId, itemData.get("trackingNr"))})
      items.push({label: "Mark as Delivered", cmd: requestChangePackageDeliveryStatusDelivered(this.props.orderId, itemData.get("trackingNr"))})
    }

    this.props.showContextualMenu(items, x, y);
  }
}

export default connect(null, {
  showContextualMenu,
  requestRemovePackageFromShippingOrder,
  requestChangePackageDeliveryStatusDelivered,
  requestChangePackageDeliveryStatusPickedUp
  })(PackagesList);